import { gql } from '@/__generated__/gql';

export const UPDATES_TAB_LIST_DOCUMENT_RECORDS_IDS_QUERY = gql(`
  query UpdatesTabListDocumentRecordsIds($data: DocumentRecordsListDto!) {
    listDocumentRecords(data: $data) {
      records {
        id
        status
      }
    }
  }
`);
